import { createFileRoute } from '@tanstack/react-router';
import FileNumberView from '../../../features/baseData/fileNumbers/fileNumber/view';
import {
  createPermissionGuard,
  FILE_NUMBERS_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/aktenzeichen/$fileNumberId')({
  component: FileNumberView,
  beforeLoad: createPermissionGuard(
    getPermissionSet(FILE_NUMBERS_PERMISSIONS, 'READ'),
  ),
});

export const ViewFileNumberRoute = Route;
